import cn from 'classnames';
import { ChangeEvent, FC } from 'react';

import { Icon, Input } from '@/Components/UI';
import { ChambersConstant } from '@/Services/IRomaStationWS';

import { calculateChamberIndexColor } from '../../../../../lib/calculateChamberIndexColor';
import { ChamberCardEditProps } from './ChamberCardEditProps';
import S from './styles.module.scss';

export const ChamberCardEdit: FC<ChamberCardEditProps> = ({
    chamber,
    onChangeSpentValue,
    maximumSpritzes: _maximumSpritzes,
    onChangeInitValue,
    onChangeProductUdi,
}) => {
    const maximumSpritzes = _maximumSpritzes || ChambersConstant.MAXIMUM_SPRITZES;

    const chamberIndexColor = calculateChamberIndexColor(chamber.init_value, chamber.spent_value);

    const createUpdateValueFn = (fn: (chamberIndex: number, value?: number) => void) => {
        return (value?: string) => {
            const numberValue = Number(value);

            if (!Number.isNaN(numberValue)) {
                fn(chamber.index, numberValue);
            }
        };
    };

    const createOnInputFn = (maxValue?: number) => (event: ChangeEvent<HTMLInputElement>) => {
        if (maxValue) {
            const value = Number(event.currentTarget.value);

            if (!Number.isNaN(value) && value > maxValue) {
                event.currentTarget.value = maxValue.toString();
            } else {
                event.currentTarget.value = value.toString();
            }
        }
    };

    return (
        <div className={S.Card}>
            <div className={S.Info}>
                <div className={cn(S.Index, S[`Index_${chamberIndexColor}`])}>{chamber.index}</div>
                <Input min={0} value={chamber.product_udi.toString()} onChange={createUpdateValueFn(onChangeProductUdi)} type="number" />
            </div>
            <div className={S.Values}>
                <div className={S.Value}>
                    <Icon name="whiffs-total" size={18} />
                    <Input
                        className={S.ValueInput}
                        min={0}
                        max={maximumSpritzes}
                        value={chamber.init_value.toString()}
                        onInput={createOnInputFn(maximumSpritzes)}
                        onChange={createUpdateValueFn(onChangeInitValue)}
                        type="number"
                    />
                </div>
                <div className={S.Value}>
                    <Icon name="whiffs-left" size={18} />
                    <Input
                        className={S.ValueInput}
                        min={0}
                        max={maximumSpritzes}
                        onInput={createOnInputFn(maximumSpritzes)}
                        value={String(chamber.init_value - chamber.spent_value)}
                    />
                </div>
                <div className={S.Value}>
                    <Icon name="whiffs-spent" size={18} />
                    <Input
                        className={S.ValueInput}
                        min={0}
                        value={chamber.spent_value.toString()}
                        onChange={createUpdateValueFn(onChangeSpentValue)}
                        type="number"
                    />
                </div>
            </div>
            {chamber.products.length > 0 && (
                <div className={S.Products}>
                    <p>
                        <b>Products:</b> {chamber.products.map((product) => product.name).join(', ')}
                    </p>
                </div>
            )}
        </div>
    );
};
